export interface PaymentFee {
  id: PaymentFeeIdEnum;
  name: string;
  description: string;
}

export const PaymentFeeIdEnum = {
  SHARED: 'SHARED',
  BENEFICIARY: 'BENEFICIARY',
  SENDER: 'SENDER'
} as const;

export type PaymentFeeEnum = typeof PaymentFeeIdEnum;
export type PaymentFeeIdEnum = PaymentFeeEnum[keyof PaymentFeeEnum];
